@if (processing) {
  <mat-spinner color="primary" diameter="50" value="50" strokeWidth="3" />
}

@if (!processing) {
  <table class="road-info">
    <tr>
      <td>Veinummer:</td>
      <td>{{ roadNumber || id }}</td>
    </tr>
    @for (item of summary; track item; let idx = $index) {
      <tr>
        <td>{{ item.navn }}:</td>
        <td>
          {{ item.value || 'Ingen data' }}
          @if (item.date) {
            <span class="date"
              >(<span>{{ item.date | date: AppConfig.FORMAT_DATE }}</span
              >)</span
            >
          }
        </td>
      </tr>
    }
  </table>
  @if (details.length > 0) {
    <mat-accordion [multi]="true">
      <mat-expansion-panel>
        <mat-expansion-panel-header>Detaljer</mat-expansion-panel-header>
        <mat-panel-description>
          <table class="road-details">
            @for (item of details; track item) {
              <tr>
                <td>{{ item['navn'] }}:</td>
                <td>{{ item['value'] || 'Ingen data' }}</td>
              </tr>
            }
          </table>
        </mat-panel-description>
      </mat-expansion-panel>
      @for (roadObject of roadObjects; track roadObject) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>{{ roadObject.navn }}</mat-expansion-panel-header>
          <mat-panel-description>
            @if (!isArray(roadObject.value)) {
              <span>{{ roadObject.value }}</span>
            }
            @if (isArray(roadObject.value)) {
              <table class="road-details">
                @for (item of asPropArray(roadObject.value); track item) {
                  <tr>
                    <td class="descriptor">{{ item['navn'] }}:</td>
                    <td>
                      {{ item['value'] || 'Ingen data' }}
                      @if (item.date) {
                        <span class="date"
                          >(<span>{{ item.date | date: AppConfig.FORMAT_DATE }}</span
                          >)</span
                        >
                      }
                    </td>
                  </tr>
                }
              </table>
            }
          </mat-panel-description>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
  @if (!roadObjects?.length) {
    <div class="no-road-objects">Ingen veiobjekter er registrert</div>
  }
}
